<template>
  <v-menu
      bottom
      left
      offset-x
      v-model="openFormDashboard"
      origin="top right"
      content-class="menu-content-list-type"
      transition="scale-transition"
      :close-on-content-click="false"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on">
        <v-icon class="appbar-icon"> mdi-view-dashboard</v-icon>
      </v-btn>
    </template>

    <template>
      <div class="wrapper-content-item-type">
        <span v-for="itemType in listType"
              class="border-table py-1">
            <v-menu
                bottom
                offset-y
                content-class="menu-dropdown-school-level"
            >
              <template v-slot:activator="{ on, attrs }">
                <span
                    color="primary"
                    dark
                    :class="itemType.id == filterForm.typeId ? 'item-type item-type-selected' : 'item-type'"
                    v-bind="attrs"
                    @click="selectType(itemType)"
                    v-on="on"
                >
                  {{itemType.name}}
                </span>
              </template>

              <v-list v-if="itemType.id" class="module-menu">
                <v-list-item
                    v-for="(item, index) in itemType.schoolLevel"
                    :key="index"
                    @click="selectSchoolLevel(item)"
                >
                  <v-list-item-title
                      :class="item.id == filterForm.schoolLevelId && itemType.id == filterForm.typeId ?
                      'item-school-level-selected' : 'item-school-level'"
                  >{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </span>
      </div>
    </template>
  </v-menu>
</template>

<script>
  import TokenService from "@/helpers/token";
  import RepositoryFactory from "@/repositories/RepositoryFactory";
  const SchoolLevelRepository = RepositoryFactory.get('school_level')
  const TypeRepository = RepositoryFactory.get('type')
  const UserRepository = RepositoryFactory.get('user')

  export default {
    name: 'SelectTypeSchoolLevelDashboard',
    props: {
      breadcrumb: {
        default: () => ([])
      }
    },
    data () {
      return {
        listType: [],
        filterForm: {
          typeId: '',
          schoolLevelId: ''
        },
        listSchoolLevel: [],
        openFormDashboard: false,
        tempType: ''
      }
    },
    async created() {
      await this.getListModule()
      this.getFilterForm()
      // this.getListType();
      // this.getListSchoolLevel();

      Bus.$on('change-drawer-side-bar', (filter) => {
        this.filterForm.schoolLevelId = filter.schoolLevelId
        this.filterForm.typeId = filter.typeId
      })
    },
    beforeDestroy() {
      Bus.$off('change-drawer-side-bar')
    },
    methods: {
      async getListModule() {
        const user = TokenService.getUser();
        let response = {};
        if (user.isManager) {
          if (this.$store.state.listSchoolLevelDrawer) {
            response['data'] = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
          } else {
            response = await SchoolLevelRepository.listTypeSchoolLevel()
          }
          response['data'].unshift({
            id: '',
            name: "Tất cả"
          })
        } else {
          if (this.$store.state.listModuleUser) {
            response['data'] = this.$store.state.listModuleUser
          } else {
            response = await UserRepository.listModuleView()
          }
        }
        this.listType = response?.data || []
      },
      selectSchoolLevel(itemSch) {
        this.filterForm.schoolLevelId = itemSch.id
        this.filterForm.typeId = this.tempType
        this.openFormDashboard = false
        Bus.$emit('change-menu-side-bar', this.filterForm)
      },
      selectType(itemType) {
        this.tempType = itemType.id
        if(!itemType.id) {
          this.filterForm.typeId = itemType.id
          Bus.$emit('change-menu-side-bar', this.filterForm)
        }
      },
      getFilterForm() {
        const user = TokenService.getUser();
        if(user.isManager) {
          this.filterForm.typeId = this.$store.state.module.typeId ? this.$store.state.module.typeId : ''
          this.filterForm.schoolLevelId = this.$store.state.module.schoolLevelId ? this.$store.state.module.schoolLevelId : ''
        } else if (!user.isCTV && !user.isMarketing) {
          this.filterForm.typeId = this.$store.state.module.typeId ? this.$store.state.module.typeId : this.listType[0].id
          this.filterForm.schoolLevelId = this.$store.state.module.schoolLevelId ? this.$store.state.module.schoolLevelId : this.listType[0]?.schoolLevel[0]?.id
        } else {
          this.filterForm.typeId = user.typeId
          this.filterForm.schoolLevelId = user.schoolLevelId
        }
      }
    }
  }
</script>

<style scoped lang="css">
  .v-text-field {
    padding-top: 0px !important;
  }
  .item-type-selected {
    background: #7E75DD;
    color: #FFFFFF !important;
  }
  .wrapper-content-item-type {
    background-color: white;
    border: 6px solid #D7D3F2;
    overflow-y: hidden;
    border-radius: 5px;
    font-size: 18px;
  }
  .menu-dropdown-school-level {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  .item-type {
    min-width: 149px;
    display: inline-block;
    text-align: center;
    width: fit-content;
    padding: 0 10px;
    color: #B9B9B9;
  }
  /deep/ .module-menu.v-list {
    background: #d7d3f2;
  }
  /deep/.item-school-level-selected {
    color: #4C458D !important;
    font-weight: bold !important;
  }
  /deep/.item-school-level {
    font-weight: unset !important;
    color: #8C8C8C !important;
  }
  .menu-content-list-type {
    top: 2px !important;
  }
</style>